import { combineReducers } from 'redux';
import OnBoardingReducer from '../screens/onBoarding/onBoardingReducer';
import ProjectReducer from '../screens/Projects/ProjectReducer';
import NavigationReducer from '../Navigation/NavigationRedux/NavigationRedux';
import ProjectUnitReducer from '../screens/ProjectsUnit/ProjectUnitReducer';
import BookingReducer from '../screens/Booking/BookingReducer';

export default () => combineReducers({
    OnBoardingReducer: OnBoardingReducer,
    ProjectReducer: ProjectReducer,
    ProjectUnitReducer: ProjectUnitReducer,
    NavigationReducer: NavigationReducer,
    BookingReducer: BookingReducer,
});